import { render, staticRenderFns } from "./SystemSettingsPayment.vue?vue&type=template&id=7771fea8"
import script from "./SystemSettingsPayment.vue?vue&type=script&lang=js"
export * from "./SystemSettingsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports